import "./../styles/main.scss";
// JQuery Ecosystem
import $ from "jquery";
import Swal from 'sweetalert2';
const datepicker = require('js-datepicker');
const moment = require("moment");
require("./helpers/jQueryPlugins");
require("jquery.scrollto");
const axios = require('axios').default;
import { carouselWrapper } from "./helpers/CarouselWrapper";
// GDPR Custom System
// require ('./helpers/CookieConsent');
// Controllers
require("./helpers/newsletterController");
require("./Registration");
$(document).ready(function () {
    carouselWrapper();
    $("body").on("click", "a[data-goto]", (e) => {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href");
        if (node.length) {
            const posY = $(node).offset().top - $("#main-header").height();
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    });
    $('body').on("click", ".shared-item", (e) => {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", (e) => {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $("body").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", (e) => {
        e.preventDefault();
        const elm = $(e.currentTarget).attr("href");
        if ($(elm).length) {
            const posY = $(elm).offset().top - ($("#main-header").height() + 20);
            $.scrollTo(posY, 400);
        }
    });
    var lastScrollTop = 0;
    let scrollFn = function () {
        var st = $(window).scrollTop();
        if (st > 250) {
            $('#main-header').addClass('scrolled');
        }
        else {
            $('#main-header').removeClass('scrolled');
        }
        lastScrollTop = st;
    };
    $(window).scroll(scrollFn);
    scrollFn.call(null);
    $("body").on("click", "*[data-link]", (e) => {
        document.location = $(e.currentTarget).attr("data-link");
    });
    $("body").on("click", ".activate-contest, a[href='#open-contest']", (e) => {
        $("#contest").addClass("open");
    });
    $("body").on("click", ".close-contest", (e) => {
        $("#contest").addClass("close");
        setTimeout(() => {
            $("#contest").removeClass("close open");
        }, 800);
    });
    const players = Array.from(document.querySelectorAll('.player-video')).map((p) => {
        let player = new Plyr(p);
        player.on("ended", (event) => {
            $(document).trigger("nextVideo");
        });
    });
    if ($("#dispositif-gate").length) {
        let isValidDate = false;
        let baseDate = moment($("#dispositif-gate").attr("data-date"));
        let dateSelected = false;
        let dateValue = "";
        // let popUpFormNode = $("#pop-up-form").html();
        // Empty node to avoid conflict
        // $("#pop-up-form").html("");
        datepicker('#directorvalidation', {
            alwaysShow: true,
            startDay: 1,
            customDays: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
            customMonths: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
            overlayButton: 'Go!',
            overlayPlaceholder: 'Année (4 chiffres)',
            formatter: (input, date, instance) => {
                input.value = moment(date).format("YYYYMMDD");
                dateValue = moment(date).format("DD-MM-YYYY");
            },
            onSelect: (instance) => {
                isValidDate = (instance.dateSelected.getTime() > baseDate.format("x"));
                dateSelected = true;
            }
        });
        $("#pop-up-form").on("submit", (e) => {
            e.preventDefault();
            let postData = new FormData();
            postData.append("firstname", $("#swalfirstname").val());
            postData.append("lastname", $("#swallastname").val());
            postData.append("email", $("#swalemail").val());
            postData.append("dispositif", $("#dispositif-gate").attr("data-dispositif"));
            postData.append("function", $("#swalfunction").val());
            postData.append("service", $("#swalservice").val());
            postData.append("phone", $("#swalphone").val());
            postData.append("date", dateValue);
            axios.post("/module/subscription/attendees", postData).then((response) => {
                if (response.status == 200) {
                    if (response.data.success == true) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Succès !',
                            html: response.data.message,
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            timer: 8000,
                            timerProgressBar: true,
                            willClose: () => {
                                document.location.reload();
                            }
                        });
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Erreur !',
                            html: response.data.message,
                            showConfirmButton: true,
                            allowOutsideClick: true
                        });
                    }
                }
            });
        });
        $("#dispositif-gate").on("submit", (e) => {
            if (!isValidDate) {
                e.preventDefault();
                if (!dateSelected) {
                    Swal.fire({
                        icon: 'error',
                        title: '',
                        html: "<h3>Erreur !</h3><p>Veuillez choisir une date d'entrée en service!</p>",
                    });
                    return true;
                }
                $("#dispositif-gate").fadeOut(250, () => {
                    $("#pop-up-form").fadeIn(200);
                    $.scrollTo($("#pop-up-form").offset().top - 150, 300);
                });
                // (async () => {
                //     const { value: formValues } = await Swal.fire({
                //       title: '',
                //       showCloseButton: true,
                //       allowOutsideClick: false,
                //       confirmButtonText: 'Envoyer <i class="fa fa-arrow-right"></i>',
                //       html: popUpFormNode,
                //       focusConfirm: false,
                //       focusCancel: false,
                //       preConfirm: () => {
                //         let firstname = $("body").find('#swalfirstname').val();
                //         let lastname = $("body").find("#swallastname").val();
                //         let email = $("body").find("#swalemail").val();
                //         console.log(firstname, lastname, email);
                //         let emailIsValid = (/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i).test(email);
                //         let fNameIsValid = firstname.length >= 2 && firstname != "";
                //         let lNameIsValid = lastname.length >= 2 && lastname != "";
                //         if (!(emailIsValid && fNameIsValid && lNameIsValid)) {
                //             Swal.showValidationMessage($("#pop-up-form").attr("data-error"));
                //         } else {
                //             return [ firstname, lastname, email ]
                //         }
                //       }
                //     });
                //     if (formValues) {
                //         await Swal.fire({
                //             title: 'Enregistrement en cours',
                //             showCloseButton: false,
                //             allowOutsideClick: false,
                //             showConfirmButton: false,
                //             didOpen: () => {
                //                 let postData = new FormData();
                //                 postData.append("firstname", formValues[0]);
                //                 postData.append("lastname", formValues[1]);
                //                 postData.append("email", formValues[2]);
                //                 postData.append("dispositif", $("#dispositif-gate").attr("data-dispositif"))
                //                 axios.post("/module/subscription/attendees", postData).then((response) => {
                //                     if (response.status == 200) {
                //                       if (response.data.success == true) {
                //                         Swal.fire({
                //                           icon: 'success',
                //                           title: 'Succès !',
                //                           html: response.data.message,
                //                         });
                //                       } else {
                //                         Swal.fire({
                //                           icon: 'error',
                //                           title: 'Erreur !',
                //                           html: response.data.message,
                //                           showConfirmButton: true,
                //                           allowOutsideClick: true
                //                         });
                //                       }
                //                     }
                //                   });
                //             }
                //         });
                //     }
                // })()
            }
        });
    }
});
